export function formatPrice(price) {
  return price.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export function getLangStr(key) {
  const value = {
    zh: '简体中文',
    en: 'English',
    th: 'ไทย',
    ja: '日文',
    ko: '한국인',
    vi: 'Tiếng Việt',
  }
  return value[key]
}

export function formatDateUTC(date) {
  date = new Date(date)
  const year = date.getUTCFullYear()
  const month = (date.getUTCMonth() + 1).toString().padStart(2, '0') // Month is zero-based
  const day = date.getUTCDate().toString().padStart(2, '0')
  const hours = date.getUTCHours().toString().padStart(2, '0')
  const minutes = date.getUTCMinutes().toString().padStart(2, '0')
  const seconds = date.getUTCSeconds().toString().padStart(2, '0')
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}
